module.exports = {
    width: 1920,
    height: 1080,
    coverWidth: 2080,
    coverHeight: 1260
}


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/DefaultProjectSize.js